import {useState} from 'react';

const useSetAnswers = () => {
  const [answers, setAnswers] = useState<IRadioAnswers[]>([]);
  const handleAnswers = (answer: IRadioAnswers) => {
    let newAnswers = [...answers];
    const findAnswers = newAnswers.find(item => item.name === answer.name);
    if (findAnswers) {
      const filtredAnswers = newAnswers.filter(
        item => item.name !== findAnswers.name,
      );
      newAnswers = [...filtredAnswers, {...findAnswers, guid: answer.guid}];
    } else {
      newAnswers.push(answer);
    }
    setAnswers(newAnswers);
  };
  return {answers, handleAnswers};
};

export default useSetAnswers;
